import { gql } from 'graphql-tag';

export default gql`
  query GetUsersAdmin($input: GetUsersAdminInput!) {
    getUsersAdmin(input: $input) {
      count
      results {
        id
        first_name
        last_name
        email
        cellphone
        lifetime_value_total
        events_attended_total
        events_attended_this_year
        customer_since
        last_purchase_date
        accounts_count
      }
    }
  }
`;
